import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Container, Content, Hero, HeroBody, Title } from 'bloomer'

import Head from '../components/head'
import Layout from '../components/layout'
import Link from '../components/link'

export class Tag extends Component {
  render() {
    const posts = this.props.data.allMarkdownRemark.edges
    const postLinks = posts.map(post => (
      <li key={post.node.fields.slug}>
        <Content isSize={'large'} style={{ margin: '1rem auto' }}>
          <a href={`/${post.node.fields.slug}`}>
            {post.node.frontmatter.title}
          </a>
        </Content>
      </li>
    ))

    return (
      <Layout>
        <Head>
          <meta name="robots" content="noindex" />
        </Head>
        <Hero isSize={'large'}>
          <HeroBody>
            <Container hasTextAlign={`centered`}>
              <Title isSize={1}>
                {' '}
                {this.props.data.allMarkdownRemark.totalCount}
                {` `}
                posts tagged with “{this.props.pageContext.tag}”
              </Title>
              <ul>{postLinks}</ul>
              <Content isSize={'large'}>
                <Link to="/route-nation/tags">Browse all tags</Link>
              </Content>
            </Container>
          </HeroBody>
        </Hero>
      </Layout>
    )
  }
}

export const tagQuery = graphql`
  query TagQuery($tag: String) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] }, draft: { ne: true } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`

export default Tag
